export const initHeaderBurger = () => {
    const container = document.getElementById('headerBurgerContainer');
    const button = document.getElementById('headerBurgerButton');
    const root = document.querySelector('[data-header-dropdown-root]');
    if (!container || !button || !root || container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    const menu = container.querySelector('.header__actions-burger-menu');
    if (!menu) return;
    if (!CSS.supports('inset-inline', '0px')) {
        menu.style.left = '0';
        menu.style.right = '0';
    }
    const mobile = window.matchMedia('(max-width: 1024px)');
    const placeholder = document.createElement('span');
    placeholder.className = 'header__actions-burger-placeholder';
    placeholder.setAttribute('aria-hidden', 'true');
    let isOpen = false;

    const close = (restoreFocus = false) => {
        if (!isOpen) return;
        isOpen = false;
        container.classList.remove('burger_active');
        button.setAttribute('aria-expanded', 'false');
        placeholder.parentNode.replaceChild(container, placeholder);
        container.removeAttribute('style');
        menu.style.removeProperty('--burger-content-top');
        if (restoreFocus) button.focus();
    };

    button.addEventListener('click', () => {
        if (isOpen) {
            close(true);
            return;
        }
        if (!mobile.matches) return;
        const rect = container.getBoundingClientRect();
        const direction = window.getComputedStyle(container).direction;
        placeholder.style.width = rect.width + 'px';
        placeholder.style.height = rect.height + 'px';
        container.parentNode.insertBefore(placeholder, container);
        root.appendChild(container);
        container.style.position = 'fixed';
        container.style.top = rect.top + 'px';
        container.style.direction = direction;
        const offset = direction === 'rtl'
            ? document.documentElement.clientWidth - rect.right
            : rect.left;
        // Fallback for browsers that predate logical inset properties.
        const inset = CSS.supports('inset-inline-start', '0px')
            ? 'inset-inline-start'
            : (direction === 'rtl' ? 'right' : 'left');
        container.style.setProperty(inset, offset + 'px');
        menu.style.setProperty('--burger-content-top', Math.max(110, rect.bottom + 20) + 'px');
        isOpen = true;
        container.classList.add('burger_active');
        button.setAttribute('aria-expanded', 'true');
        button.focus();
    });

    document.addEventListener('keydown', (event) => {
        if (isOpen && event.key === 'Escape') {
            event.preventDefault();
            close(true);
        }
    });
    document.addEventListener('click', (event) => {
        if (isOpen && !container.contains(event.target)) close();
        else if (isOpen && event.target.closest('a')) close();
    });
    document.addEventListener('focusin', (event) => {
        if (isOpen && !container.contains(event.target)) close();
    });
    let viewportWidth = document.documentElement.clientWidth;
    window.addEventListener('resize', () => {
        const nextWidth = document.documentElement.clientWidth;
        // Mobile browser bars can resize the height while scrolling.
        if (nextWidth !== viewportWidth) close();
        viewportWidth = nextWidth;
    });
};
